export default "__VITE_ASSET__BsVobN7U__"